import { render, staticRenderFns } from "./applyActivitySubmitView.vue?vue&type=template&id=21f87580"
import script from "./applyActivitySubmitView.vue?vue&type=script&lang=js"
export * from "./applyActivitySubmitView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports